"use client";
import React, { useState } from "react";
import cn from "clsx";

import styles from "./TalentAcrossIndustries.module.scss";
import { industries } from "./utils";


function IndustryIcon({ icon, label }: { icon: React.ReactNode; label: string }) {
  if (typeof icon === "string") {
    return <img src={icon} alt={label} />;
  }
  if (icon) {
    return <>{icon}</>;
  }
  return <span className={styles.iconFallback}>{label.charAt(0)}</span>;
}

export default function TalentAcrossIndustries({isMobile=false}) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const active = industries[activeIndex];

  return (
    <div >
      <div className={styles.container}>
        <h2 className={styles.heading}>Transforming Talent Across Industries</h2>

        <div className={styles.layout}>
          <div className={styles.tabsGrid}>
            {industries.map((industry, index) => {
              const isSelected = index === activeIndex;
              const showHoveredIcon = isSelected && industry.hoveredIcon;
              return (
                <button
                  key={industry.id}
                  type="button"
                  className={cn(styles.tab, index === activeIndex && styles.tabActive)}
                  onClick={() => setActiveIndex(index)}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                >
                  <span className={cn(styles.tabIcon, showHoveredIcon && styles.tabIconRaw)}>
                    <IndustryIcon
                      icon={showHoveredIcon ? industry.hoveredIcon : industry.icon}
                      label={isMobile? industry?.MwebLabel?.length > 0? industry?.MwebLabel: industry.label: industry.label}
                    />
                  </span>
                  <span className={styles.tabLabel}>{industry.label}</span>
                </button>
              );
            })}
          </div>

          <div className={styles.infoCard}>
            <div className={styles.infoHeader}>
              <span className={cn(styles.infoIcon, active.hoveredIcon && styles.infoIconRaw)}>
                <IndustryIcon icon={active.hoveredIcon ?? active.icon} label={active.label} />
              </span>
              <h3>{active.label}</h3>
            </div>

            <div className={styles.desktopBody}>
              <div className={styles.listHeader}>
                <span>Popular Career Paths</span>
                <span>Open Positions</span>
              </div>
              <ul className={styles.list}>
                {active.careerPaths.map((path) => (
                  <li key={path.name} className={styles.listRow}>
                    <span>{path.name}</span>
                    <span>{path.positions}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className={styles.mobileBody}>
              <span className={styles.pillLabel}>
                Career Paths In {active.label}
              </span>
              <div className={styles.pillRow}>
                {active.careerPaths.slice(0, 3).map((path) => (
                  <span key={path.name} className={styles.pill}>
                    {path.name}
                  </span>
                ))}
              </div>

              <div className={styles.statRow}>
                <span>Open positions</span>
                <span>{active.openPositions}</span>
              </div>
              <div className={styles.statRow}>
                <span>Starting salary (INR)</span>
                <span>{active.startingSalary}</span>
              </div>
            </div>

            <div className={styles.source}>Source: {active.source}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
